import React from "react";
import Heading from "../../Components/Heading";
import { Link } from "react-router-dom";

const Instructions = () => {
  return (
    <div className="max-w-2xl mx-auto p-6">
      <Heading level={1} className="mt-3 mb-8">
        Avatar Instructions
      </Heading>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
        <p className="text-yellow-800 font-medium mb-2">
          Ready Player Me Service Discontinued
        </p>
        <p className="text-yellow-700 text-sm">
          The Ready Player Me avatar service has been discontinued.
          You can now choose from our pre-built avatar library instead.
        </p>
      </div>

      <div className="bg-gray-50 rounded-lg p-6">
        <Heading level={3} className="mb-4">
          How to Select Your Avatar
        </Heading>
        <ol className="list-decimal list-inside space-y-3 text-gray-700">
          <li>Navigate to the Avatar page from the top menu</li>
          <li>Browse the available avatars in the "Fun" or "Serious" tabs</li>
          <li>Click on an avatar to preview it</li>
          <li>Click "Select" to confirm your choice</li>
        </ol>

        <div className="mt-6">
          <Link
            to="/avatar/modify"
            className="inline-block bg-primary text-white px-6 py-3 rounded-md hover:opacity-90 transition-opacity"
          >
            Choose Your Avatar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
